import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postPmCheck({ body }) {
  return BaseService.post(REST.PM_CHECKS, body);
}

function putPmCheck({ body, id }) {
  return BaseService.put(REST.PM_CHECKS_ID(id), body);
}

function getPmChecks(params) {
  return BaseService.get(REST.PM_CHECKS, {
    params: paramsFilter({ params }),
  });
}

function deletePmChecks({ id }) {
  return BaseService.delete(REST.PM_CHECKS_ID(id));
}

export default {
  getPmChecks,
  postPmCheck,
  putPmCheck,
  deletePmChecks,
};
